<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <div class="imgBlock">
        <img alt="" src="../../assets/svg/removeIcon.png">
        <h1>Удалить карту?</h1>
        <p>Это действие невозможно будет отменить</p>
      </div>
    </div>

    <div>
      <button class="whiteButton" v-on:click="closePopUp">Отменить</button>
      <button class="purpleButton" v-on:click="removeCard">Удалить</button>
    </div>
  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';
import { mapState } from 'vuex';
import { getUserCards, removeSelectedCard } from '@/requests/kariRequests'
import { catchError } from '@/globalFunctions/functions'

export default {
  name: 'remove-card',
  components: { CrossIcon },
  methods: {
    closePopUp () {
      this.$store.commit('closePopUp');
    },
    async removeCard () {
      this.$store.commit('showLoader', true);
      await removeSelectedCard(this.card.cardId)
        .then(async (res) => {
          catchError(res).then(async () => {
            this.$store.commit('showLoader', false);
            this.closePopUp();
            await getUserCards().then((res) => {
              catchError(res).then((res) => {
                this.$store.dispatch('prepareCardsInfo', res);
                this.$store.commit('showLoader', false);
              }).catch(() => {
                this.$store.commit('showLoader', false);
              })
            })
          }).catch(async () => {
            this.$store.commit('showLoader', false);
            this.closePopUp();
            await getUserCards().then((res) => {
              catchError(res).then((res) => {
                this.$store.dispatch('prepareCardsInfo', res);
                this.$store.commit('showLoader', false);
              }).catch(() => {
                this.$store.commit('showLoader', false);
              })
            })
          });
        })
    }
  },
  computed: {
    ...mapState({
      card: state => state.cards.selectedCard
    })
  }
};
</script>

<style scoped>
#popUpWin { height: calc(165.33vw - 10.67vw); display: flex; flex-direction: column; justify-content: space-between }
#popUpWin>div>.imgBlock>h1 { margin-bottom: 2.13vw }
#popUpWin>div:last-child { display: flex; flex-direction: column }
#popUpWin>div:last-child>button { padding: 3.20vw 0 }
#popUpWin>div:last-child>button:first-child { margin-bottom: 2.13vw }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { height: calc(383px - 40px); width: calc(450px - 40px) }
  #popUpWin>div>.imgBlock>h1 { margin-bottom: 20px }
  #popUpWin>div:last-child { flex-direction: row; justify-content: space-between; }
  #popUpWin>div:last-child>button { padding: 16px 0; width: 201px }
  #popUpWin>div:last-child>button:first-child { margin-bottom: 0 }
}

</style>
